var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_3_1057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1923 6.8745L9.89695 14.1674L8.83644 13.1067L8.94593 12.9972H7.50376C7.22846 12.9972 7.00322 12.772 7.00322 12.4967V11.0544L6.89404 11.1639C6.74607 11.314 6.63751 11.4955 6.57839 11.6957L5.85949 14.1423L8.30462 13.4227C8.47668 13.3633 8.68628 13.2538 8.83644 13.1067L9.89695 14.1674C9.57161 14.4927 9.16805 14.7336 8.72695 14.8619L4.96259 15.9694C4.69918 16.0477 4.41419 15.9757 4.21992 15.7536C4.02564 15.5878 3.953 15.303 4.03053 15.0371L5.13778 11.2734C5.26792 10.8322 5.50661 10.4286 5.83227 10.1033L13.1254 2.80853L17.1923 6.8745ZM19.4134 1.82019C20.1955 2.60204 20.1955 3.87101 19.4134 4.65317L17.8993 6.16743L13.8324 2.10083L15.3466 0.586572C16.1287 -0.195524 17.3988 -0.195524 18.1809 0.586572L19.4134 1.82019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_1057",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_1057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_1057",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVector);
export default __webpack_public_path__ + "static/media/profile-Vector.0ca57bab26ea5431997630b64624ee2b.svg";
export { ForwardRef as ReactComponent };